import { createSelector } from 'reselect';
import studentSelector from './student';

export default createSelector(studentSelector, (student) => student?.curriculumId);
